import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/complex/:id",
    name: "complex",
    component: () => import("../views/ComplexView.vue"),
    props: true,
  },
  {
    path: "/apartment/:id",
    name: "apartment",
    component: () => import("../views/ApartmentView.vue"),
    props: true,
  },
  {
    path: "/new_buildings",
    name: "NewBuildingView",
    component: () => import("../views/NewBuildingView.vue"),
  },
  {
    path: "/favorite",
    name: "FavortieView",
    component: () => import("../views/FavoriteView.vue"),
  },
  {
    path: "/buying",
    name: "BuyingView",
    component: () => import("../views/BuyingView.vue"),
  },
  {
    path: "/about",
    name: "AboutView",
    component: () => import("../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
